import React from 'react';

const Overview = ({ project }) => {
  return (
    <section id="overview">
      <h1>{project.name}</h1>
      <div className="content">
        <img className="thumbnail" src={project.thumbnail} alt={project.name} />
        <div className="details">
          <p><span className="label">Catégorie:</span> <span className="value">{project.category}</span></p>
          <p><span className="label">Date:</span> <span className="value">{project.date}</span></p>
          <p><span className="label">Lieu:</span> <span className="value">{project.location}</span></p>
          <p><span className="label">Client:</span> <span className="value">{project.client}</span></p>
          <p><span className="label">Type de relevé:</span> <span className="value">{project.type}</span></p>
          <br/><p className="projdetails">{project.description}</p>
        </div>
      </div>
    </section>
  );
};

export default Overview;
